import * as Yup from "yup";

const ResetPasswordEmailSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email address is not valid.")
    .required("Email address is required."),
});

export default ResetPasswordEmailSchema;
